import React from 'react';
import { Link } from 'react-router-dom';

const Footer = ({ testimonials, onOpenPrivacy }) => {
  return (
    <footer className="site-footer" id="testimonials">
      <div className="footer-container">
        {/* Left Column: Trusted by 500+ Clients + Review Pills */}
        <div className="footer-testimonials-col">
          <div className="trusted-badge">
            <span className="trusted-title">Trusted by</span>
            <span className="trusted-count">200+ Clients</span>
          </div>

          <div className="testimonial-pills">
            {testimonials && testimonials.map((t) => (
              <div className="testimonial-pill" key={t.id}>
                {/* Photo avatar commented out for now; will add back in future */}
                {/* <img src={t.avatarUrl} alt={t.clientName} className="testimonial-avatar" /> */}
                <div className="testimonial-info">
                  <div className="testimonial-stars">
                    {[...Array(t.rating || 5)].map((_, i) => (
                      <i className="bi bi-star-fill" key={i} style={{ marginRight: '2px' }}></i>
                    ))}
                  </div>
                  <div className="testimonial-quote">"{t.comment}"</div>
                  <div className="testimonial-author">- {t.clientName} ({t.clientLocation})</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right Column: Social Follow */}
        <div className="footer-social-col">
          <span className="social-title">Follow Me</span>
          <div className="social-icons">
            <a href="https://www.facebook.com/61591002587975/" target="_blank" rel="noopener noreferrer" className="social-icon-btn" aria-label="Facebook" title="Facebook">
              <i className="bi bi-facebook"></i>
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon-btn" aria-label="Instagram" title="Instagram">
              <i className="bi bi-instagram"></i>
            </a>
            <a
              href="https://xhslink.cn/m/2UFYsp4Nof3"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon-btn"
              aria-label="RedNote / Xiaohongshu"
              title="RedNote / 小红书 Profile"
            >
              <span style={{ fontSize: '0.72rem', fontWeight: '800', letterSpacing: '-0.5px' }}>RED</span>
            </a>
            <a
              href="https://www.propertyguru.com.my/property-agents/nicole-pua-901697876"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon-btn"
              aria-label="PropertyGuru"
              title="PropertyGuru Profile"
            >
              <i className="bi bi-house-door-fill"></i>
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Bar: Copyright & Privacy Policy */}
      <div className="footer-bottom-bar">
        <div className="footer-bottom-container">
          <span className="footer-copyright">
            © {new Date().getFullYear()} Nicole Pua Real Estate Negotiator. All rights reserved.
          </span>
          <span className="footer-divider">•</span>
          <Link
            to="/privacy-policy"
            className="footer-privacy-btn"
            onClick={onOpenPrivacy}
          >
            Privacy Policy
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
